import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import arrayDiffer from "array-differ";
import styled from "styled-components";
import { db } from "../Utils/Firebase";
import { AppContext } from "../Utils/AppContext";
import { useGetAllCompanies } from "../Utils/Company";
import { getAllUsers, useGetAllUsers, removeUserFleet } from "../Utils/User";
import { createFleet, useGetFleet, updateFleet } from "../Utils/Fleet";

const FormContainer = styled.div`
  margin-top: 30px;

  form {
    label {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }
    p.error-message {
      margin-bottom: 12px;
      color: #d94a38;
      font-size: 14px;
    }
  }
`;

const Input = styled.input`
  border: ${props => (!props.fieldValid ? "solid 1px #d94a38" : "solid 1px #dbdee5")};
  padding: 10px;
  border-radius: 3px;
  font-size: 14px;
  margin-top: 4px;
`;

const FleetFormCreate = ({ companyId, formComplete, hideManagersAndDrivers }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const { loading: loadingCompanies, companies } = useGetAllCompanies();
  const { users: allCompanyFleetManagers, loading: loadingAllCompanyFleetManagers } = useGetAllUsers(
    companyId,
    null,
    "fleet-manager"
  );
  const { users: allCompanyDrivers, loading: loadingAllCompanyDrivers } = useGetAllUsers(companyId, null, "driver");

  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [location, setLocation] = useState("");
  const [company, setCompany] = useState("");
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedFleetManagers, setSelectedFleetManagers] = useState([]);
  const [fleetManagerRefs, setFleetManagerRefs] = useState(null);
  const [driverRefs, setDriverRefs] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);

  const [validateForm, setValidateForm] = useState(false);
  const [formValid, setFormValid] = useState(true);

  const selectStyles = {
    container: (provided, state) => {
      if (validateForm && !state.hasValue) return { ...provided, border: "solid 1px #d94a38" };
      else return { ...provided };
    }
  };

  const createRefs = values =>
    new Promise((resolve, reject) => {
      if (values) {
        const refs = [];

        values.forEach(value => refs.push(db.doc(`/users/${value.uid}`)));
        resolve(refs);
      }
    });

  const getDriversFromRef = async drivers => {
    const parsedDrivers = [];
    let i = 0;

    // if (typeof drivers === object) {

    // } else {

    // }

    drivers.forEach(driver => {
      i += 1;

      driver.get().then(driverInfo => {
        parsedDrivers.push(driverInfo.data());
        if (parsedDrivers.length === i) setSelectedDrivers(parsedDrivers);
      });

      // const driverInfo = await driver.get();
      // parsedDrivers.push(driverInfo.data());

      // if (parsedDrivers.length === i) console.log(parsedDrivers);
    });
  };

  useEffect(() => {
    if (!loadingCompanies) {
      const options = [];

      companies.map((comp, index) => {
        options.push({ value: comp.cid, label: comp.name });
        if (companies.length === index + 1) return setCompanyOptions(options);
      });
    }
  }, [loadingCompanies]);

  return (
    <FormContainer>
      <form>
        <label htmlFor="fleetName">
          Fleet Name:
          <br />
          <Input
            fieldValid={validateForm ? name : true}
            type="text"
            name="fleetName"
            id="fleetName"
            onChange={event => setName(event.target.value)}
            value={name}
          />
        </label>
        <br />
        <label htmlFor="customerName">
          Customer Name:
          <br />
          <Input
            fieldValid={validateForm ? customerName : true}
            type="text"
            name="customerName"
            id="customerName"
            onChange={event => setCustomerName(event.target.value)}
            value={customerName}
          />
        </label>
        <br />
        <label htmlFor="location">
          Location:
          <br />
          <Input
            fieldValid={validateForm ? location : true}
            type="text"
            name="location"
            id="location"
            onChange={event => setLocation(event.target.value)}
            value={location}
          />
        </label>
        <br />

        {currentUser.role === "super" && (
          <div>
            <label htmlFor="company">
              Company:
              <Select
                // defaultValue={}
                // isMulti
                name="company"
                value={company}
                options={companyOptions}
                styles={selectStyles}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Company"
                // defaultValue="a"
                onChange={event => {
                  setCompany(event);
                }}
              />
            </label>
            <br />
          </div>
        )}

        {!hideManagersAndDrivers && (
          <div>
            <label htmlFor="fleetManager">
              Fleet Manager:
              {!loadingAllCompanyFleetManagers && (
                <Select
                  options={allCompanyFleetManagers}
                  value={selectedFleetManagers}
                  getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                  getOptionValue={({ uid }) => uid}
                  // defaultValue={[driverOptions[0], driverOptions[1]]}
                  placeholder="Select Fleet Manager"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(newValue, actionMeta) => {
                    // createRefs(newValue).then(refs => {
                    //   setSelectedFleetManagers(newValue);
                    //   setFleetManagerRefs(refs);
                    // });
                    setSelectedFleetManagers(newValue);
                    setFleetManagerRefs(db.doc(`/users/${newValue.uid}`));
                  }}
                />
              )}
            </label>

            <br />

            <label htmlFor="drivers">
              Drivers:
              {!loadingAllCompanyDrivers && (
                <Select
                  isMulti
                  name="drivers"
                  options={allCompanyDrivers.filter(d => !d.fleet)}
                  value={selectedDrivers}
                  fieldValid={validateForm ? company : true}
                  getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                  getOptionValue={({ uid }) => uid}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Fleet Drivers"
                  onChange={(newValue, actionMeta) => {
                    createRefs(newValue).then(refs => {
                      setSelectedDrivers(newValue);
                      setDriverRefs(refs);
                    });
                  }}
                />
              )}
            </label>
          </div>
        )}

        {!formValid && <p className="error-message">Please fill out all required fields.</p>}

        <button
          type="button"
          onClick={() => {
            if (!name || !customerName || !location || (currentUser.role === "super" && !company)) {
              setValidateForm(true);
              setFormValid(false);
            } else {
              const cid = currentUser.role === "super" ? company.value : companyId;
              createFleet(cid, name, customerName, location, driverRefs, fleetManagerRefs).then(() => {
                if (formComplete) {
                  formComplete();
                }
              });
            }
          }}
        >
          Create Fleet
        </button>
      </form>
    </FormContainer>
  );
};

const FleetFormUpdate = ({ companyId, fleetId, formComplete }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;
  // Set form mode
  const [formMode, setFormMode] = useState("create");

  // Load Fleet Data
  const { fleet, loading: loadingFleet } = useGetFleet(fleetId, companyId);
  const { users: allCompanyFleetManagers, loading: loadingAllCompanyFleetManagers } = useGetAllUsers(
    companyId,
    null,
    "fleet-manager"
  );
  const { users: allCompanyDrivers, loading: loadingAllCompanyDrivers } = useGetAllUsers(companyId, null, "driver");

  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [location, setLocation] = useState("");
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedFleetManagers, setSelectedFleetManagers] = useState([]);
  const [fleetManagerRefs, setFleetManagerRefs] = useState(null);
  const [driverRefs, setDriverRefs] = useState([]);

  const [validateForm, setValidateForm] = useState(false);
  const [formValid, setFormValid] = useState(true);

  const createRefs = values =>
    new Promise((resolve, reject) => {
      if (values) {
        const refs = [];

        values.forEach(value => refs.push(db.doc(`/users/${value.uid}`)));
        resolve(refs);
      }
    });

  const getDriversFromRef = async drivers => {
    const parsedDrivers = [];
    let i = 0;

    // if (typeof drivers === object) {

    // } else {

    // }

    drivers.forEach(driver => {
      i += 1;
      driver.get().then(driverInfo => {
        parsedDrivers.push(driverInfo.data());
        if (parsedDrivers.length === i) setSelectedDrivers(parsedDrivers);
      });

      // const driverInfo = await driver.get();
      // parsedDrivers.push(driverInfo.data());

      // if (parsedDrivers.length === i) console.log(parsedDrivers);
    });
  };

  const getFleetManagerFromRef = fleetManager => {
    if (fleetManager) {
      fleetManager.get().then(fleetManagerInfo => setSelectedFleetManagers(fleetManagerInfo.data()));
    }
  };

  const setExistingValues = async () => {
    if (!loadingFleet && fleet) {
      setDriverRefs(fleet.driverRefs);
      setSelectedDrivers(fleet.drivers);

      setFleetManagerRefs(fleet.fleetManager);
      getFleetManagerFromRef(fleet.fleetManager);

      setCustomerName(fleet.customerName);
      setLocation(fleet.location);
      setName(fleet.name);
    }
  };

  useEffect(() => {
    if (fleetId) {
      setFormMode("edit");
      setExistingValues();
    }

    // if (!loadingAllCompanyFleetManagers) {
    //   console.log('All Fleet Managers =>', allCompanyFleetManagers);
    // }

    // if (!loadingAllCompanyDrivers) {
    //   console.log(createRefs(allCompanyDrivers));
    // }

    // if (!loadingFleet) {
    //   console.log('Fleet =>', fleet);
    // }
  }, [allCompanyFleetManagers, allCompanyDrivers, fleet]);

  return (
    <FormContainer>
      <form>
        {currentUser.role !== "fleet-manager" && (
          <div>
            <label htmlFor="fleetName">
              Fleet Name:
              <br />
              <Input
                fieldValid={validateForm ? name : true}
                type="text"
                name="fleetName"
                id="fleetName"
                onChange={event => setName(event.target.value)}
                value={name}
              />
            </label>
            <br />
            <label htmlFor="customerName">
              Customer Name:
              <br />
              <Input
                fieldValid={validateForm ? customerName : true}
                type="text"
                name="customerName"
                id="customerName"
                onChange={event => setCustomerName(event.target.value)}
                value={customerName}
              />
            </label>
            <br />
            <label htmlFor="location">
              Location:
              <br />
              <Input
                fieldValid={validateForm ? location : true}
                type="text"
                name="location"
                id="location"
                onChange={event => setLocation(event.target.value)}
                value={location}
              />
            </label>
            <br />

            {fleetId ? (
              <label htmlFor="fleetManager">
                Fleet Manager:
                {!loadingAllCompanyFleetManagers && !loadingFleet && (
                  <Select
                    options={allCompanyFleetManagers}
                    value={selectedFleetManagers}
                    getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                    getOptionValue={({ uid }) => uid}
                    // defaultValue={[driverOptions[0], driverOptions[1]]}
                    placeholder="Select Fleet Manager"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(newValue, actionMeta) => {
                      // createRefs(newValue).then(refs => {
                      //   setSelectedFleetManagers(newValue);
                      //   setFleetManagerRefs(refs);
                      // });
                      setSelectedFleetManagers(newValue);
                      setFleetManagerRefs(db.doc(`/users/${newValue.uid}`));
                    }}
                  />
                )}
              </label>
            ) : (
              <label htmlFor="fleetManager">
                Fleet Manager:
                {!loadingAllCompanyFleetManagers && (
                  <Select
                    options={allCompanyFleetManagers}
                    value={selectedFleetManagers}
                    getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                    getOptionValue={({ uid }) => uid}
                    // defaultValue={[driverOptions[0], driverOptions[1]]}
                    placeholder="Select Fleet Manager"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(newValue, actionMeta) => {
                      // createRefs(newValue).then(refs => {
                      //   setSelectedFleetManagers(newValue);
                      //   setFleetManagerRefs(refs);
                      // });
                      setSelectedFleetManagers(newValue);
                      setFleetManagerRefs(db.doc(`/users/${newValue.uid}`));
                    }}
                  />
                )}
              </label>
            )}
            <br />
          </div>
        )}
        {fleetId ? (
          <label htmlFor="drivers">
            Drivers:
            {!loadingAllCompanyDrivers && !loadingFleet && (
              <Select
                isMulti
                name="drivers"
                options={allCompanyDrivers.filter(d => !d.fleet)}
                value={selectedDrivers}
                getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                getOptionValue={({ uid }) => uid}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Fleet Drivers"
                onChange={(newValue, actionMeta) => {
                  createRefs(newValue).then(refs => {
                    setSelectedDrivers(newValue);
                    setDriverRefs(refs);
                  });
                }}
              />
            )}
          </label>
        ) : (
          <label htmlFor="drivers">
            Drivers:
            {!loadingAllCompanyDrivers && (
              <Select
                isMulti
                name="drivers"
                options={allCompanyDrivers.filter(d => !d.fleet)}
                value={selectedDrivers}
                getOptionLabel={({ name }) => `${name.firstName} ${name.lastName}`}
                getOptionValue={({ uid }) => uid}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Fleet Drivers"
                onChange={(newValue, actionMeta) => {
                  createRefs(newValue).then(refs => {
                    setSelectedDrivers(newValue);
                    setDriverRefs(refs);
                  });
                }}
              />
            )}
          </label>
        )}

        {!formValid && <p className="error-message">Please fill out all required fields.</p>}

        <button
          type="button"
          onClick={() => {
            if (!name || !customerName || !location) {
              setValidateForm(true);
              setFormValid(false);
            } else {
              if (formMode === "create") {
                createFleet(companyId, name, customerName, location, driverRefs, fleetManagerRefs).then(() => {
                  if (formComplete) {
                    formComplete();
                  }
                });
              } else {
                updateFleet(
                  companyId,
                  fleetId,
                  name,
                  customerName,
                  location,
                  driverRefs,
                  fleetManagerRefs,
                  fleet.fleetManager,
                  fleet.drivers
                ).then(() => {
                  if (formComplete) {
                    formComplete();
                  }
                });
              }
            }
          }}
        >
          {formMode === "create" ? "Create Fleet" : "Update Fleet"}
        </button>
      </form>
    </FormContainer>
  );
};

export { FleetFormUpdate, FleetFormCreate };
